export type BrandId = "nomzy" | "shake-salad";

export interface BrandConfig {
  id: BrandId;
  name: string;
  logo: string;
  logo_white?: string;
  colors: {
    primary: string;
    primaryHover: string;
    accent: string;
    secondary: string;
    tertiary: string;
    quaternary: string;
    primaryActiveBg: string;
    greytext: string;
    mainbody: string;
    errorBg: string;
    backgroundColor: string;
    textColor: string;
    footerText: string;
    tastebudButtonText: string;
    productCarouselText: string;
    videoButtonText: string;
    topbarCollectionText: string;
    collectionProductButtonText: string;
    smartFridgeContactText: string;
    smartFridgeContactLink: string;
    white: string;
    black: string;
    transparent: string;
    divider: string;
    softBackground: string;
    subtleBackground: string;
    mutedBackground: string;
    disabledBackground: string;
    disabledBorder: string;
    mutedText: string;
    voucherTimeText: string;
    successText: string;
    successLight: string;
    rewardNegative: string;
    warningBackground: string;
    paymentPurple: string;
    whatsapp: string;
    whatsappHover: string;
    overlayBlack30: string;
    overlayBlack50: string;
    overlayBlack70: string;
    overlayBlack80: string;
    overlayBlack04: string;
    overlayBlack03: string;
    overlayBlack12: string;
    overlayBlack23: string;
    overlayWhite50: string;
    overlayWhite70: string;
    shadow07: string;
    shadow10: string;
    shadow20: string;
  };
}

export const BRAND_CONFIGS: Record<BrandId, BrandConfig> = {
  nomzy: {
    id: "nomzy",
    name: "NOMZY",
    logo: require("../assets/images/nomzy_logo.png"),
    logo_white: require("../assets/images/nomzy_logo.png"),
    colors: {
      primary: "#ff5e2c",
      primaryHover: "#ff5e2c",
      accent: "#346c43",
      secondary: "#f9f8ed",
      tertiary: "#000000",
      quaternary: "#f9f4d2",
      primaryActiveBg: "#346c43",
      greytext: "#aaaaaa",
      mainbody: "#f9f8ed",
      errorBg: "#ff3333",
      backgroundColor: "#FCF9F7",
      textColor: "#333333",
      footerText: "#000000",
      tastebudButtonText: "#000000",
      productCarouselText: "#000000",
      videoButtonText: "#000000",
      topbarCollectionText: "#000000",
      collectionProductButtonText: "#000000",
      smartFridgeContactText: "#000000",
      smartFridgeContactLink: "#f9f4d2",
      white: "#ffffff",
      black: "#000000",
      transparent: "transparent",
      divider: "#dddddd",
      softBackground: "#f9f9f9",
      subtleBackground: "#f7f7f7",
      mutedBackground: "#f0f0f0",
      disabledBackground: "#e0e0e0",
      disabledBorder: "#cfcfcf",
      mutedText: "#5D5D5D",
      voucherTimeText: "#4E4E4E",
      successText: "#136936",
      successLight: "#a3cf69",
      rewardNegative: "#FF7043",
      warningBackground: "#fff8db",
      paymentPurple: "#90137b",
      whatsapp: "#25D366",
      whatsappHover: "#128C7E",
      overlayBlack30: "rgba(0, 0, 0, 0.3)",
      overlayBlack50: "rgba(0, 0, 0, 0.5)",
      overlayBlack70: "rgba(0, 0, 0, 0.7)",
      overlayBlack80: "rgba(0, 0, 0, 0.8)",
      overlayBlack04: "rgba(0, 0, 0, 0.04)",
      overlayBlack03: "rgba(0, 0, 0, 0.03)",
      overlayBlack12: "rgba(0, 0, 0, 0.12)",
      overlayBlack23: "rgba(0, 0, 0, 0.23)",
      overlayWhite50: "rgba(255, 255, 255, 0.5)",
      overlayWhite70: "rgba(255, 255, 255, 0.7)",
      shadow07: "rgba(0, 0, 0, 0.07)",
      shadow10: "rgba(0, 0, 0, 0.1)",
      shadow20: "rgba(0, 0, 0, 0.2)",
    },
  },
  "shake-salad": {
    id: "shake-salad",
    name: "SHAKE SALAD",
    logo: require("../assets/images/shakesalad2.png"),
    logo_white: require("../assets/images/shakesalad3.png"),
    colors: {
      // primary: "#086b3a",
      primary: "#064c0a",
      primaryHover: "#07552f",
      accent: "#65bb45",
      secondary: "#f9f8ed",
      tertiary: "#000000",
      quaternary: "#f9f4d2",
      primaryActiveBg: "#65bb45",
      greytext: "#aaaaaa",
      mainbody: "#f9f8ed",
      errorBg: "#ff3333",
      backgroundColor: "#FCF9F7",
      textColor: "#333333",
      footerText: "#f9f8ed",
      tastebudButtonText: "#f9f8ed",
      productCarouselText: "#f9f8ed",
      videoButtonText: "#f9f8ed",
      topbarCollectionText: "#f9f8ed",
      collectionProductButtonText: "#f9f8ed",
      smartFridgeContactText: "#f9f8ed",
      smartFridgeContactLink: "#f9f8ed",
      white: "#ffffff",
      black: "#000000",
      transparent: "transparent",
      divider: "#dddddd",
      softBackground: "#f9f9f9",
      subtleBackground: "#f7f7f7",
      mutedBackground: "#f0f0f0",
      disabledBackground: "#e0e0e0",
      disabledBorder: "#cfcfcf",
      mutedText: "#5D5D5D",
      voucherTimeText: "#4E4E4E",
      successText: "#136936",
      successLight: "#a3cf69",
      rewardNegative: "#FF7043",
      warningBackground: "#fff8db",
      paymentPurple: "#90137b",
      whatsapp: "#25D366",
      whatsappHover: "#128C7E",
      overlayBlack30: "rgba(0, 0, 0, 0.3)",
      overlayBlack50: "rgba(0, 0, 0, 0.5)",
      overlayBlack70: "rgba(0, 0, 0, 0.7)",
      overlayBlack80: "rgba(0, 0, 0, 0.8)",
      overlayBlack04: "rgba(0, 0, 0, 0.04)",
      overlayBlack03: "rgba(0, 0, 0, 0.03)",
      overlayBlack12: "rgba(0, 0, 0, 0.12)",
      overlayBlack23: "rgba(0, 0, 0, 0.23)",
      overlayWhite50: "rgba(255, 255, 255, 0.5)",
      overlayWhite70: "rgba(255, 255, 255, 0.7)",
      shadow07: "rgba(0, 0, 0, 0.07)",
      shadow10: "rgba(0, 0, 0, 0.1)",
      shadow20: "rgba(0, 0, 0, 0.2)",
    },
  },
};

const developmentHosts: Record<string, BrandId> = {
  "nomzy.local": "nomzy",
  "shakesalad.local": "shake-salad",
};

const localhostNames = new Set(["localhost", "127.0.0.1", "::1"]);

const isHostnameOrSubdomainOf = (hostname: string, domain: string): boolean =>
  hostname === domain || hostname.endsWith(`.${domain}`);

export const getBrandForHostname = (
  hostname: string,
  search = "",
  isDevelopment = process.env.NODE_ENV === "development"
): BrandConfig | undefined => {
  const normalizedHostname = hostname.toLowerCase().replace(/\.$/, "");

  if (isHostnameOrSubdomainOf(normalizedHostname, "nomzy.club")) {
    return BRAND_CONFIGS.nomzy;
  }
  if (isHostnameOrSubdomainOf(normalizedHostname, "shakesalad.com")) {
    return BRAND_CONFIGS["shake-salad"];
  }

  if (isDevelopment) {
    const override = new URLSearchParams(search).get("brand");
    if (override === "nomzy" || override === "shake-salad") {
      return BRAND_CONFIGS[override];
    }

    if (localhostNames.has(normalizedHostname)) {
      return BRAND_CONFIGS.nomzy;
    }
    const localBrand = developmentHosts[normalizedHostname];
    if (localBrand) {
      return BRAND_CONFIGS[localBrand];
    }
  }

  return undefined;
};

const activeBrand =
  typeof window === "undefined"
    ? undefined
    : getBrandForHostname(window.location.hostname, window.location.search);

export const getCurrentBrand = (): BrandConfig | undefined => activeBrand;

export const applyBrandTheme = (
  brand: BrandConfig,
  element: HTMLElement = document.documentElement
): void => {
  element.dataset.brand = brand.id;
  Object.entries(brand.colors).forEach(([name, value]) => {
    const variableName =
      name === "backgroundColor"
        ? "background"
        : name
            .replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)
            .replace(/(\d+)$/, "-$1");
    element.style.setProperty(`--color-${variableName}`, value);
  });
  element.ownerDocument
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", brand.colors.primary);
};
